import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, inject } from "@angular/core"
import { ColorPaletteService } from "@shared/services/color-palette.service"
import { IconImageService } from "@shared/services/icon-image.service"

let uniqueId = 0

@Component({
  selector: "flow-checkbox-v2",
  templateUrl: "./flow-checkbox-v2.component.html",
  styleUrl: "./flow-checkbox-v2.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FlowCheckboxV2Component {
  iconService = inject(IconImageService)
  colorService = inject(ColorPaletteService)

  @Input() checkedImg: string = this.iconService.Icon.check_rounded
  @Input() indeterminateImg: string = this.iconService.Icon.minus
  @Input() disabled: boolean = false
  @Input() destructive: boolean = false
  @Input() checked: boolean = false
  @Input() indeterminate: boolean = false
  @Input() radio: boolean = false
  @Input() label: string = ""
  @Input() helperText: string = ""
  @Input() ariaLabel: string = ""
  @Input() emitOnChange: boolean = true
  @Output() checkedChange = new EventEmitter<boolean>()

  public readonly labelId = `flow-checkbox-label-${uniqueId}`
  public readonly helperId = `flow-checkbox-helper-${uniqueId++}`

  public get ariaChecked(): boolean | "mixed" {
    return this.indeterminate ? "mixed" : this.checked
  }

  public get labelledBy(): string | null {
    return this.label ? this.labelId : null
  }

  public get describedBy(): string | null {
    return this.helperText ? this.helperId : null
  }

  public setCheck() {
    if (this.disabled) {
      return
    }
    if (this.indeterminate) {
      this.indeterminate = false
      this.checked = true
    } else {
      this.checked = !this.checked
    }
    if (this.emitOnChange) {
      this.checkedChange.emit(this.checked)
    }
  }

  public onKeydown(event: KeyboardEvent) {
    if (event.key === " " || event.key === "Spacebar") {
      event.preventDefault()
      this.setCheck()
    }
  }

  public isFilled(): boolean {
    return (this.checked || this.indeterminate) && !this.disabled
  }

  public hasContent(): boolean {
    return !!(this.label || this.helperText)
  }

  public showTick(): boolean {
    return this.checked && !this.indeterminate && !this.radio
  }

  public showMinus(): boolean {
    return this.indeterminate && !this.radio
  }

  public getDotColor(): string {
    if (!this.checked && !this.indeterminate) {
      return "transparent"
    }
    return this.disabled ? this.colorService.neutral400 : "#fff"
  }
}
